/**
 * Auto-generated Locale Data File for ko-KR.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */

import type { NumberFormat, NumbersData, NameItem, LanguagesData, LocaleData, TimeZone, TimeZoneList, WeekData, WeekDayNameData, NameSet, WeekDayNames } from '../types';

const languages: LanguagesData = {
    id: 55,
    bcp47Tag: 'ko-KR',
    name: 'Korean',
    localizedName: '한국어',
    localizedNameList: [
        {
            id: 24,
            name: '네덜란드어',
        },
        {
            id: 69,
            name: '노르웨이어(보크말)',
        },
        {
            id: 68,
            name: '덴마크어',
        },
        {
            id: 18,
            name: '독일어',
        },
        {
            id: 8,
            name: '러시아어',
        },
        {
            id: 70,
            name: '벵골어',
        },
        {
            id: 57,
            name: '스웨덴어',
        },
        {
            id: 10,
            name: '스페인어',
        },
        {
            id: 72,
            name: '스페인어 (라틴 아메리카)',
        },
        {
            id: 4,
            name: '영어',
        },
        {
            id: 59,
            name: '영어 (영국)',
        },
        {
            id: 67,
            name: '영어 (오스트레일리아)',
        },
        {
            id: 66,
            name: '영어 (캐나다)',
        },
        {
            id: 16,
            name: '이탈리아어',
        },
        {
            id: 19,
            name: '일본어',
        },
        {
            id: 6,
            name: '중국어 (undefined)',
        },
        {
            id: 63,
            name: '중국어 (undefined)',
        },
        {
            id: 49,
            name: '터키어',
        },
        {
            id: 14,
            name: '포르투갈어',
        },
        {
            id: 30,
            name: '폴란드어',
        },
        {
            id: 21,
            name: '프랑스어',
        },
        {
            id: 65,
            name: '프랑스어 (캐나다)',
        },
        {
            id: 61,
            name: '핀란드어',
        },
        {
            id: 55,
            name: '한국어',
        },
        {
            id: 71,
            name: '힌디어',
        },
    ],
};

const numbers: NumbersData = {
    long: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number}천',
        },
        {
            digits: 1,
            msg: '{count, number}만',
        },
        {
            digits: 2,
            msg: '{count, number}만',
        },
        {
            digits: 3,
            msg: '{count, number}만',
        },
        {
            digits: 4,
            msg: '{count, number}만',
        },
        {
            digits: 1,
            msg: '{count, number}억',
        },
        {
            digits: 2,
            msg: '{count, number}억',
        },
        {
            digits: 3,
            msg: '{count, number}억',
        },
        {
            digits: 4,
            msg: '{count, number}억',
        },
        {
            digits: 1,
            msg: '{count, number}조',
        },
        {
            digits: 2,
            msg: '{count, number}조',
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number}천',
        },
        {
            digits: 1,
            msg: '{count, number}만',
        },
        {
            digits: 2,
            msg: '{count, number}만',
        },
        {
            digits: 3,
            msg: '{count, number}만',
        },
        {
            digits: 4,
            msg: '{count, number}만',
        },
        {
            digits: 1,
            msg: '{count, number}억',
        },
        {
            digits: 2,
            msg: '{count, number}억',
        },
        {
            digits: 3,
            msg: '{count, number}억',
        },
        {
            digits: 4,
            msg: '{count, number}억',
        },
        {
            digits: 1,
            msg: '{count, number}조',
        },
        {
            digits: 2,
            msg: '{count, number}조',
        },
    ],
};

const timezones: Array<TimeZone> = [
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 키리티마티 +14',
        nameLocalized: '키리티마티',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Etc/GMT-14',
        displayName: 'GMT+14:00 GMT-14 +14',
        nameLocalized: 'GMT-14',
        abbreviationStandard: '+14',
        id: 375
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 아피아 +13/+14',
        nameLocalized: '아피아',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 통가타푸 +13/+14',
        nameLocalized: '통가타푸',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 파카오푸 +13',
        nameLocalized: '파카오푸',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Etc/GMT-13',
        displayName: 'GMT+13:00 GMT-13 +13',
        nameLocalized: 'GMT-13',
        abbreviationStandard: '+13',
        id: 374
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 채텀 +1245/+1345',
        nameLocalized: '채텀',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 나우루 +12',
        nameLocalized: '나우루',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 마주로 +12',
        nameLocalized: '마주로',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 맥머도 NZST',
        nameLocalized: '맥머도',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 아나디리 +12',
        nameLocalized: '아나디리',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 오클랜드 NZST',
        nameLocalized: '오클랜드',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 월리스 +12',
        nameLocalized: '월리스',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 웨이크 +12',
        nameLocalized: '웨이크',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 캄차카 +12',
        nameLocalized: '캄차카',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 콰잘렌 +12',
        nameLocalized: '콰잘렌',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 타라와 +12',
        nameLocalized: '타라와',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 푸나푸티 +12',
        nameLocalized: '푸나푸티',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 피지 +12/+13',
        nameLocalized: '피지',
        abbreviationStandard: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 474
    },
    {
        name: 'NZ',
        displayName: 'GMT+12:00 NZ NZST',
        nameLocalized: 'NZ',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 483
    },
    {
        name: 'Antarctica/South_Pole',
        displayName: 'GMT+12:00 South Pole NZST',
        nameLocalized: 'South Pole',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 209
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 과달카날 +11',
        nameLocalized: '과달카날',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 노퍽 +11/+12',
        nameLocalized: '노퍽',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 누메아 +11/+12',
        nameLocalized: '누메아',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 마가단 +11',
        nameLocalized: '마가단',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 사할린 +11',
        nameLocalized: '사할린',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 에파테 +11/+12',
        nameLocalized: '에파테',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 코스레 +11',
        nameLocalized: '코스레',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+11:00 포나페 +11',
        nameLocalized: '포나페',
        abbreviationStandard: '+11',
        id: 513
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 로드 하우 +1030/+11',
        nameLocalized: '로드 하우',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/LHI',
        displayName: 'GMT+10:30 LHI +1030/+11',
        nameLocalized: 'LHI',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 318
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 괌 ChST',
        nameLocalized: '괌',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 뒤몽 뒤르빌 +10',
        nameLocalized: '뒤몽 뒤르빌',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 린데만 AEST',
        nameLocalized: '린데만',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 멜버른 AEST',
        nameLocalized: '멜버른',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 브리스베인 AEST',
        nameLocalized: '브리스베인',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 블라디보스토크 +10',
        nameLocalized: '블라디보스토크',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 사이판 ChST',
        nameLocalized: '사이판',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 시드니 AEST',
        nameLocalized: '시드니',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+10:00 트루크 +10',
        nameLocalized: '트루크',
        abbreviationStandard: '+10',
        id: 521
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 포트모르즈비 +10',
        nameLocalized: '포트모르즈비',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 호바트 AEST',
        nameLocalized: '호바트',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Australia/ACT',
        displayName: 'GMT+10:00 ACT AEST',
        nameLocalized: 'ACT',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 309
    },
    {
        name: 'Australia/Canberra',
        displayName: 'GMT+10:00 Canberra AEST',
        nameLocalized: 'Canberra',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 313
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 Currie AEST',
        nameLocalized: 'Currie',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Australia/NSW',
        displayName: 'GMT+10:00 NSW AEST',
        nameLocalized: 'NSW',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 323
    },
    {
        name: 'Australia/Queensland',
        displayName: 'GMT+10:00 Queensland AEST',
        nameLocalized: 'Queensland',
        abbreviationStandard: 'AEST',
        id: 325
    },
    {
        name: 'Australia/Tasmania',
        displayName: 'GMT+10:00 Tasmania AEST',
        nameLocalized: 'Tasmania',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 328
    },
    {
        name: 'Australia/Victoria',
        displayName: 'GMT+10:00 Victoria AEST',
        nameLocalized: 'Victoria',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 329
    },
    {
        name: 'Pacific/Yap',
        displayName: 'GMT+10:00 Yap +10',
        nameLocalized: 'Yap',
        abbreviationStandard: '+10',
        id: 524
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 다윈 ACST',
        nameLocalized: '다윈',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 브로컨힐 ACST',
        nameLocalized: '브로컨힐',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 애들레이드 ACST',
        nameLocalized: '애들레이드',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/North',
        displayName: 'GMT+09:30 North ACST',
        nameLocalized: 'North',
        abbreviationStandard: 'ACST',
        id: 322
    },
    {
        name: 'Australia/South',
        displayName: 'GMT+09:30 South ACST',
        nameLocalized: 'South',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 326
    },
    {
        name: 'Australia/Yancowinna',
        displayName: 'GMT+09:30 Yancowinna ACST',
        nameLocalized: 'Yancowinna',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 331
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 도쿄 JST',
        nameLocalized: '도쿄',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 딜리 +09',
        nameLocalized: '딜리',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 서울 KST',
        nameLocalized: '서울',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 야쿠츠크 +09',
        nameLocalized: '야쿠츠크',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 자야푸라 WIT',
        nameLocalized: '자야푸라',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 팔라우 +09',
        nameLocalized: '팔라우',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 평양 KST',
        nameLocalized: '평양',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 유클라 +0845/+0945',
        nameLocalized: '유클라',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 마닐라 PST',
        nameLocalized: '마닐라',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 마카사르 WITA',
        nameLocalized: '마카사르',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 마카오 CST',
        nameLocalized: '마카오',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 브루나이 +08',
        nameLocalized: '브루나이',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 상하이 CST',
        nameLocalized: '상하이',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 싱가포르 +08',
        nameLocalized: '싱가포르',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 울란바토르 +08/+09',
        nameLocalized: '울란바토르',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 이르쿠츠크 +08',
        nameLocalized: '이르쿠츠크',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 초이발산 +08/+09',
        nameLocalized: '초이발산',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+08:00 케이시 +08',
        nameLocalized: '케이시',
        abbreviationStandard: '+08',
        id: 202
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 쿠알라룸푸르 +08',
        nameLocalized: '쿠알라룸푸르',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 쿠칭 +08',
        nameLocalized: '쿠칭',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 타이베이 CST',
        nameLocalized: '타이베이',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 퍼스 AWST',
        nameLocalized: '퍼스',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 홍콩 HKST',
        nameLocalized: '홍콩',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Chongqing',
        displayName: 'GMT+08:00 Chongqing CST',
        nameLocalized: 'Chongqing',
        abbreviationStandard: 'CST',
        id: 230
    },
    {
        name: 'Asia/Chungking',
        displayName: 'GMT+08:00 Chungking CST',
        nameLocalized: 'Chungking',
        abbreviationStandard: 'CST',
        id: 231
    },
    {
        name: 'Asia/Harbin',
        displayName: 'GMT+08:00 Harbin CST',
        nameLocalized: 'Harbin',
        abbreviationStandard: 'CST',
        id: 240
    },
    {
        name: 'Asia/Kashgar',
        displayName: 'GMT+08:00 Kashgar CST',
        nameLocalized: 'Kashgar',
        abbreviationStandard: 'CST',
        id: 251
    },
    {
        name: 'Asia/Ulan_Bator',
        displayName: 'GMT+08:00 Ulan Bator +08/+09',
        nameLocalized: 'Ulan Bator',
        abbreviationStandard: '+08/+09',
        id: 290
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 노보시비르스크 +07',
        nameLocalized: '노보시비르스크',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 데이비스 +07',
        nameLocalized: '데이비스',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 방콕 +07',
        nameLocalized: '방콕',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 비엔티안 +07',
        nameLocalized: '비엔티안',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 사이공 +07',
        nameLocalized: '사이공',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 자카르타 WIB',
        nameLocalized: '자카르타',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 크라스노야르스크 +07',
        nameLocalized: '크라스노야르스크',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 크리스마스 +07',
        nameLocalized: '크리스마스',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 폰티아나크 WIB',
        nameLocalized: '폰티아나크',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 프놈펜 +07',
        nameLocalized: '프놈펜',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 호브드 +07/+08',
        nameLocalized: '호브드',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 코코스 +0630',
        nameLocalized: '코코스',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 다카 +06/+07',
        nameLocalized: '다카',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 비슈케크 +06',
        nameLocalized: '비슈케크',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 옴스크 +06',
        nameLocalized: '옴스크',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 우루무치 +06',
        nameLocalized: '우루무치',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 차고스 +06',
        nameLocalized: '차고스',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 팀부 +06',
        nameLocalized: '팀부',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 콜롬보 +0530',
        nameLocalized: '콜롬보',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 두샨베 +05',
        nameLocalized: '두샨베',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 모슨 +05',
        nameLocalized: '모슨',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 몰디브 +05',
        nameLocalized: '몰디브',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+05:00 보스토크 +05',
        nameLocalized: '보스토크',
        abbreviationStandard: '+05',
        id: 211
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 사마르칸트 +05',
        nameLocalized: '사마르칸트',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 아슈하바트 +05',
        nameLocalized: '아슈하바트',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 아크타우 +05',
        nameLocalized: '아크타우',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 악토브 +05',
        nameLocalized: '악토브',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+05:00 알마티 +05',
        nameLocalized: '알마티',
        abbreviationStandard: '+05',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 예카테린부르크 +05',
        nameLocalized: '예카테린부르크',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 오랄 +05',
        nameLocalized: '오랄',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 카라치 PKST',
        nameLocalized: '카라치',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 케르켈렌 +05',
        nameLocalized: '케르켈렌',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 키질로르다 +05',
        nameLocalized: '키질로르다',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 타슈켄트 +05',
        nameLocalized: '타슈켄트',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 카불 +0430',
        nameLocalized: '카불',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 두바이 +04',
        nameLocalized: '두바이',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 레위니옹 +04',
        nameLocalized: '레위니옹',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 마헤 +04',
        nameLocalized: '마헤',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 모리셔스 +04/+05',
        nameLocalized: '모리셔스',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 무스카트 +04',
        nameLocalized: '무스카트',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 바쿠 +04/+05',
        nameLocalized: '바쿠',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 사마라 +04',
        nameLocalized: '사마라',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 예레반 +04/+05',
        nameLocalized: '예레반',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 트빌리시 +04',
        nameLocalized: '트빌리시',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 테헤란 +0330/+0430',
        nameLocalized: '테헤란',
        abbreviationStandard: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 나이로비 EAT',
        nameLocalized: '나이로비',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 다르에스살람 EAT',
        nameLocalized: '다르에스살람',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+03:00 다마스쿠스 +03',
        nameLocalized: '다마스쿠스',
        abbreviationStandard: '+03',
        id: 234
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 리야드 +03',
        nameLocalized: '리야드',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 메요트 EAT',
        nameLocalized: '메요트',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 모가디슈 EAT',
        nameLocalized: '모가디슈',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 모스크바 MSK',
        nameLocalized: '모스크바',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 민스크 +03',
        nameLocalized: '민스크',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 바그다드 +03/+04',
        nameLocalized: '바그다드',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 바레인 +03',
        nameLocalized: '바레인',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 볼고그라트 MSK',
        nameLocalized: '볼고그라트',
        abbreviationStandard: 'MSK',
        id: 443
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 쇼와 +03',
        nameLocalized: '쇼와',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 심페로폴 MSK',
        nameLocalized: '심페로폴',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 아덴 +03',
        nameLocalized: '아덴',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 아디스아바바 EAT',
        nameLocalized: '아디스아바바',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 아스메라 EAT',
        nameLocalized: '아스메라',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 안타나나리보 EAT',
        nameLocalized: '안타나나리보',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+03:00 암만 +03',
        nameLocalized: '암만',
        abbreviationStandard: '+03',
        id: 215,
        enabled: true
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 이스탄불 +03',
        nameLocalized: '이스탄불',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 지부티 EAT',
        nameLocalized: '지부티',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 카타르 +03',
        nameLocalized: '카타르',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 캄팔라 EAT',
        nameLocalized: '캄팔라',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 코모로 EAT',
        nameLocalized: '코모로',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 쿠웨이트 +03',
        nameLocalized: '쿠웨이트',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Africa/Asmara',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 5
    },
    {
        name: 'Asia/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 407
    },
    {
        name: 'Europe/Tiraspol',
        displayName: 'GMT+03:00 Tiraspol MSK/MSD',
        nameLocalized: 'Tiraspol',
        abbreviationStandard: 'MSK/MSD',
        id: 437
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 가보로네 CAT',
        nameLocalized: '가보로네',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 가자 EET',
        nameLocalized: '가자',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 니코시아 EET',
        nameLocalized: '니코시아',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 루붐바시 CAT',
        nameLocalized: '루붐바시',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 루사카 CAT',
        nameLocalized: '루사카',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 리가 EET',
        nameLocalized: '리가',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 마리에함 EET',
        nameLocalized: '마리에함',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 마세루 SAST',
        nameLocalized: '마세루',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 마푸토 CAT',
        nameLocalized: '마푸토',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 베이루트 EET',
        nameLocalized: '베이루트',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 부줌부라 CAT',
        nameLocalized: '부줌부라',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 부쿠레슈티 EET',
        nameLocalized: '부쿠레슈티',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 블랜타이어 CAT',
        nameLocalized: '블랜타이어',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 빈트후크 WAT',
        nameLocalized: '빈트후크',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 빌니우스 EET',
        nameLocalized: '빌니우스',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 소피아 EET',
        nameLocalized: '소피아',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 아테네 EET',
        nameLocalized: '아테네',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 예루살렘 IST',
        nameLocalized: '예루살렘',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 요하네스버그 SAST',
        nameLocalized: '요하네스버그',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 음바바네 SAST',
        nameLocalized: '음바바네',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 카르툼 CAT',
        nameLocalized: '카르툼',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 카이로 EET',
        nameLocalized: '카이로',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 칼리닌그라드 EET',
        nameLocalized: '칼리닌그라드',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 키갈리 CAT',
        nameLocalized: '키갈리',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 키시나우 EET',
        nameLocalized: '키시나우',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 키예프 EET',
        nameLocalized: '키예프',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 탈린 EET',
        nameLocalized: '탈린',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 트리폴리 EET',
        nameLocalized: '트리폴리',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 하라레 CAT',
        nameLocalized: '하라레',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 헬싱키 EET',
        nameLocalized: '헬싱키',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'EET',
        displayName: 'GMT+02:00 EET EET',
        nameLocalized: 'EET',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 350
    },
    {
        name: 'Europe/Nicosia',
        displayName: 'GMT+02:00 Nicosia EET',
        nameLocalized: 'Nicosia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 421
    },
    {
        name: 'Asia/Tel_Aviv',
        displayName: 'GMT+02:00 Tel Aviv IST',
        nameLocalized: 'Tel Aviv',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 284
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 Uzhgorod EET',
        nameLocalized: 'Uzhgorod',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 Zaporozhye EET',
        nameLocalized: 'Zaporozhye',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 니아메 WAT',
        nameLocalized: '니아메',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 더블린 IST/GMT',
        nameLocalized: '더블린',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 두알라 WAT',
        nameLocalized: '두알라',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 라고스 WAT',
        nameLocalized: '라고스',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 로마 CET',
        nameLocalized: '로마',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 롱이어비엔 CET',
        nameLocalized: '롱이어비엔',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 루안다 WAT',
        nameLocalized: '루안다',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 룩셈부르크 CET',
        nameLocalized: '룩셈부르크',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 류블랴나 CET',
        nameLocalized: '류블랴나',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 리브르빌 WAT',
        nameLocalized: '리브르빌',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 마드리드 CET',
        nameLocalized: '마드리드',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 말라보 WAT',
        nameLocalized: '말라보',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 모나코 CET',
        nameLocalized: '모나코',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 몰타 CET',
        nameLocalized: '몰타',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 바르샤바 CET',
        nameLocalized: '바르샤바',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 바티칸 CET',
        nameLocalized: '바티칸',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 방기 WAT',
        nameLocalized: '방기',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 베를린 CET',
        nameLocalized: '베를린',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 베오그라드 CET',
        nameLocalized: '베오그라드',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 부다페스트 CET',
        nameLocalized: '부다페스트',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 브라자빌 WAT',
        nameLocalized: '브라자빌',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 브라티슬라바 CET',
        nameLocalized: '브라티슬라바',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 브뤼셀 CET',
        nameLocalized: '브뤼셀',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 비엔나 CET',
        nameLocalized: '비엔나',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 사라예보 CET',
        nameLocalized: '사라예보',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 산마리노 CET',
        nameLocalized: '산마리노',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 세우타 CET',
        nameLocalized: '세우타',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 스코페 CET',
        nameLocalized: '스코페',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 스톡홀름 CET',
        nameLocalized: '스톡홀름',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 안도라 CET',
        nameLocalized: '안도라',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 알제 CET',
        nameLocalized: '알제',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 암스테르담 CET',
        nameLocalized: '암스테르담',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 엔자메나 WAT',
        nameLocalized: '엔자메나',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 엘아이운 +01/+00',
        nameLocalized: '엘아이운',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 오슬로 CET',
        nameLocalized: '오슬로',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 자그레브 CET',
        nameLocalized: '자그레브',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 지브롤터 CET',
        nameLocalized: '지브롤터',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 취리히 CET',
        nameLocalized: '취리히',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 카사블랑카 +01/+00',
        nameLocalized: '카사블랑카',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 코펜하겐 CET',
        nameLocalized: '코펜하겐',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 킨샤사 WAT',
        nameLocalized: '킨샤사',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 튀니스 CEST',
        nameLocalized: '튀니스',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 티라나 CET',
        nameLocalized: '티라나',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 파두츠 CET',
        nameLocalized: '파두츠',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 파리 CET',
        nameLocalized: '파리',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 포드고리차 CET',
        nameLocalized: '포드고리차',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 포르토노보 WAT',
        nameLocalized: '포르토노보',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 프라하 CET',
        nameLocalized: '프라하',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'CET',
        displayName: 'GMT+01:00 CET CET',
        nameLocalized: 'CET',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 345
    },
    {
        name: 'MET',
        displayName: 'GMT+01:00 MET MET',
        nameLocalized: 'MET',
        abbreviationStandard: 'MET',
        abbreviationDaylight: 'MEST',
        id: 476
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 건지 GMT/BST',
        nameLocalized: '건지',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 누악쇼트 GMT',
        nameLocalized: '누악쇼트',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 다카르 GMT',
        nameLocalized: '다카르',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 덴마크샤븐 GMT',
        nameLocalized: '덴마크샤븐',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 랑군 UTC',
        nameLocalized: '랑군',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 런던 GMT/BST',
        nameLocalized: '런던',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 레이캬비크 GMT',
        nameLocalized: '레이캬비크',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 로메 GMT',
        nameLocalized: '로메',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 리스본 WET',
        nameLocalized: '리스본',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 마데이라 WET',
        nameLocalized: '마데이라',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 맨섬 GMT/BST',
        nameLocalized: '맨섬',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 몬로비아 GMT',
        nameLocalized: '몬로비아',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 바마코 GMT',
        nameLocalized: '바마코',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 반줄 GMT',
        nameLocalized: '반줄',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 비사우 GMT',
        nameLocalized: '비사우',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 상투메 GMT',
        nameLocalized: '상투메',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 세인트 헬레나 GMT',
        nameLocalized: '세인트 헬레나',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 아비장 GMT',
        nameLocalized: '아비장',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 아크라 GMT',
        nameLocalized: '아크라',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 엔더베리 -00',
        nameLocalized: '엔더베리',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 와가두구 GMT',
        nameLocalized: '와가두구',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 저지 GMT/BST',
        nameLocalized: '저지',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 카나리아 제도 WET',
        nameLocalized: '카나리아 제도',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 카트만두 UTC',
        nameLocalized: '카트만두',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 코나크리 GMT',
        nameLocalized: '코나크리',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 콜카타 UTC',
        nameLocalized: '콜카타',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 페로 제도 UTC',
        nameLocalized: '페로 제도',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 프리타운 GMT',
        nameLocalized: '프리타운',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'US/Aleutian',
        displayName: 'GMT+00:00 Aleutian UTC',
        nameLocalized: 'Aleutian',
        abbreviationStandard: 'UTC',
        id: 536
    },
    {
        name: 'US/Arizona',
        displayName: 'GMT+00:00 Arizona UTC',
        nameLocalized: 'Arizona',
        abbreviationStandard: 'UTC',
        id: 537
    },
    {
        name: 'Asia/Ashkhabad',
        displayName: 'GMT+00:00 Ashkhabad UTC',
        nameLocalized: 'Ashkhabad',
        abbreviationStandard: 'UTC',
        id: 220
    },
    {
        name: 'America/Atka',
        displayName: 'GMT+00:00 Atka UTC',
        nameLocalized: 'Atka',
        abbreviationStandard: 'UTC',
        id: 73
    },
    {
        name: 'Canada/Atlantic',
        displayName: 'GMT+00:00 Atlantic UTC',
        nameLocalized: 'Atlantic',
        abbreviationStandard: 'UTC',
        id: 336
    },
    {
        name: 'Mexico/BajaNorte',
        displayName: 'GMT+00:00 BajaNorte UTC',
        nameLocalized: 'BajaNorte',
        abbreviationStandard: 'UTC',
        id: 477
    },
    {
        name: 'Europe/Belfast',
        displayName: 'GMT+00:00 Belfast GMT/BST',
        nameLocalized: 'Belfast',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 393
    },
    {
        name: 'US/Central',
        displayName: 'GMT+00:00 Central UTC',
        nameLocalized: 'Central',
        abbreviationStandard: 'UTC',
        id: 538
    },
    {
        name: 'Cuba',
        displayName: 'GMT+00:00 Cuba UTC',
        nameLocalized: 'Cuba',
        abbreviationStandard: 'UTC',
        id: 349
    },
    {
        name: 'Asia/Dacca',
        displayName: 'GMT+00:00 Dacca UTC',
        nameLocalized: 'Dacca',
        abbreviationStandard: 'UTC',
        id: 233
    },
    {
        name: 'Brazil/DeNoronha',
        displayName: 'GMT+00:00 DeNoronha UTC',
        nameLocalized: 'DeNoronha',
        abbreviationStandard: 'UTC',
        id: 333
    },
    {
        name: 'Canada/East-Saskatchewan',
        displayName: 'GMT+00:00 East-Saskatchewan UTC',
        nameLocalized: 'East-Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 338
    },
    {
        name: 'Chile/EasterIsland',
        displayName: 'GMT+00:00 EasterIsland UTC',
        nameLocalized: 'EasterIsland',
        abbreviationStandard: 'UTC',
        id: 347
    },
    {
        name: 'Canada/Eastern',
        displayName: 'GMT+00:00 Eastern UTC',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'UTC',
        id: 339
    },
    {
        name: 'Egypt',
        displayName: 'GMT+00:00 Egypt UTC',
        nameLocalized: 'Egypt',
        abbreviationStandard: 'UTC',
        id: 351
    },
    {
        name: 'Eire',
        displayName: 'GMT+00:00 Eire UTC',
        nameLocalized: 'Eire',
        abbreviationStandard: 'UTC',
        id: 352
    },
    {
        name: 'Factory',
        displayName: 'GMT+00:00 Factory -00',
        nameLocalized: 'Factory',
        abbreviationStandard: '-00',
        id: 448
    },
    {
        name: 'Atlantic/Faroe',
        displayName: 'GMT+00:00 Faroe WET',
        nameLocalized: 'Faroe',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 302
    },
    {
        name: 'GB',
        displayName: 'GMT+00:00 GB UTC',
        nameLocalized: 'GB',
        abbreviationStandard: 'UTC',
        id: 449
    },
    {
        name: 'GB-Eire',
        displayName: 'GMT+00:00 GB-Eire UTC',
        nameLocalized: 'GB-Eire',
        abbreviationStandard: 'UTC',
        id: 450
    },
    {
        name: 'Etc/GMT',
        displayName: 'GMT+00:00 GMT GMT',
        nameLocalized: 'GMT',
        abbreviationStandard: 'GMT',
        id: 355
    },
    {
        name: 'GMT',
        displayName: 'GMT+00:00 GMT UTC',
        nameLocalized: 'GMT',
        abbreviationStandard: 'UTC',
        id: 451
    },
    {
        name: 'Etc/GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 369
    },
    {
        name: 'GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 453
    },
    {
        name: 'Etc/GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 356
    },
    {
        name: 'GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 452
    },
    {
        name: 'Etc/GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 384
    },
    {
        name: 'GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 454
    },
    {
        name: 'Etc/Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 385
    },
    {
        name: 'Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 455
    },
    {
        name: 'Hongkong',
        displayName: 'GMT+00:00 Hongkong UTC',
        nameLocalized: 'Hongkong',
        abbreviationStandard: 'UTC',
        id: 456
    },
    {
        name: 'Iceland',
        displayName: 'GMT+00:00 Iceland GMT',
        nameLocalized: 'Iceland',
        abbreviationStandard: 'GMT',
        id: 458
    },
    {
        name: 'Iran',
        displayName: 'GMT+00:00 Iran UTC',
        nameLocalized: 'Iran',
        abbreviationStandard: 'UTC',
        id: 470
    },
    {
        name: 'Israel',
        displayName: 'GMT+00:00 Israel UTC',
        nameLocalized: 'Israel',
        abbreviationStandard: 'UTC',
        id: 471
    },
    {
        name: 'Jamaica',
        displayName: 'GMT+00:00 Jamaica UTC',
        nameLocalized: 'Jamaica',
        abbreviationStandard: 'UTC',
        id: 472
    },
    {
        name: 'Japan',
        displayName: 'GMT+00:00 Japan UTC',
        nameLocalized: 'Japan',
        abbreviationStandard: 'UTC',
        id: 473
    },
    {
        name: 'Libya',
        displayName: 'GMT+00:00 Libya UTC',
        nameLocalized: 'Libya',
        abbreviationStandard: 'UTC',
        id: 475
    },
    {
        name: 'Asia/Macao',
        displayName: 'GMT+00:00 Macao UTC',
        nameLocalized: 'Macao',
        abbreviationStandard: 'UTC',
        id: 257
    },
    {
        name: 'US/Michigan',
        displayName: 'GMT+00:00 Michigan UTC',
        nameLocalized: 'Michigan',
        abbreviationStandard: 'UTC',
        id: 543
    },
    {
        name: 'US/Mountain',
        displayName: 'GMT+00:00 Mountain UTC',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'UTC',
        id: 544
    },
    {
        name: 'Navajo',
        displayName: 'GMT+00:00 Navajo UTC',
        nameLocalized: 'Navajo',
        abbreviationStandard: 'UTC',
        id: 482
    },
    {
        name: 'NZ-CHAT',
        displayName: 'GMT+00:00 NZ-CHAT UTC',
        nameLocalized: 'NZ-CHAT',
        abbreviationStandard: 'UTC',
        id: 484
    },
    {
        name: 'US/Pacific-New',
        displayName: 'GMT+00:00 Pacific-New UTC',
        nameLocalized: 'Pacific-New',
        abbreviationStandard: 'UTC',
        id: 546
    },
    {
        name: 'Poland',
        displayName: 'GMT+00:00 Poland UTC',
        nameLocalized: 'Poland',
        abbreviationStandard: 'UTC',
        id: 525
    },
    {
        name: 'Portugal',
        displayName: 'GMT+00:00 Portugal UTC',
        nameLocalized: 'Portugal',
        abbreviationStandard: 'UTC',
        id: 526
    },
    {
        name: 'PRC',
        displayName: 'GMT+00:00 PRC UTC',
        nameLocalized: 'PRC',
        abbreviationStandard: 'UTC',
        id: 527
    },
    {
        name: 'ROC',
        displayName: 'GMT+00:00 ROC UTC',
        nameLocalized: 'ROC',
        abbreviationStandard: 'UTC',
        id: 529
    },
    {
        name: 'ROK',
        displayName: 'GMT+00:00 ROK UTC',
        nameLocalized: 'ROK',
        abbreviationStandard: 'UTC',
        id: 530
    },
    {
        name: 'Canada/Saskatchewan',
        displayName: 'GMT+00:00 Saskatchewan UTC',
        nameLocalized: 'Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 343,
        enabled: true
    },
    {
        name: 'America/Shiprock',
        displayName: 'GMT+00:00 Shiprock UTC',
        nameLocalized: 'Shiprock',
        abbreviationStandard: 'UTC',
        id: 183
    },
    {
        name: 'Singapore',
        displayName: 'GMT+00:00 Singapore UTC',
        nameLocalized: 'Singapore',
        abbreviationStandard: 'UTC',
        id: 531
    },
    {
        name: 'Asia/Thimbu',
        displayName: 'GMT+00:00 Thimbu UTC',
        nameLocalized: 'Thimbu',
        abbreviationStandard: 'UTC',
        id: 285
    },
    {
        name: 'Africa/Timbuktu',
        displayName: 'GMT+00:00 Timbuktu GMT',
        nameLocalized: 'Timbuktu',
        abbreviationStandard: 'GMT',
        id: 50
    },
    {
        name: 'Turkey',
        displayName: 'GMT+00:00 Turkey UTC',
        nameLocalized: 'Turkey',
        abbreviationStandard: 'UTC',
        id: 532
    },
    {
        name: 'Etc/UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 386
    },
    {
        name: 'UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 533
    },
    {
        name: 'Asia/Ujung_Pandang',
        displayName: 'GMT+00:00 Ujung Pandang UTC',
        nameLocalized: 'Ujung Pandang',
        abbreviationStandard: 'UTC',
        id: 288
    },
    {
        name: 'Etc/Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 387
    },
    {
        name: 'Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 534
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 548
    },
    {
        name: 'W-SU',
        displayName: 'GMT+00:00 W-SU UTC',
        nameLocalized: 'W-SU',
        abbreviationStandard: 'UTC',
        id: 549
    },
    {
        name: 'Australia/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 330
    },
    {
        name: 'Brazil/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 335
    },
    {
        name: 'WET',
        displayName: 'GMT+00:00 WET WET',
        nameLocalized: 'WET',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 550
    },
    {
        name: 'Etc/Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 389
    },
    {
        name: 'Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 551,
        enabled: true
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 아조레스 -01/+00',
        nameLocalized: '아조레스',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 카보 베르데 -01',
        nameLocalized: '카보 베르데',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'Etc/GMT-1',
        displayName: 'GMT-01:00 GMT-1 -01',
        nameLocalized: 'GMT-1',
        abbreviationStandard: '-01',
        id: 370
    },
    {
        name: 'Etc/GMT+1',
        displayName: 'GMT-01:00 GMT+1 -01',
        nameLocalized: 'GMT+1',
        abbreviationStandard: '-01',
        id: 357
    },
    {
        name: 'Atlantic/Jan_Mayen',
        displayName: 'GMT-01:00 Jan Mayen -01',
        nameLocalized: 'Jan Mayen',
        abbreviationStandard: '-01',
        id: 303
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 노롱야 -02',
        nameLocalized: '노롱야',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 사우스조지아 -02',
        nameLocalized: '사우스조지아',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-02:00 스코레스바이선드 -02/-01',
        nameLocalized: '스코레스바이선드',
        abbreviationStandard: '-02/-01',
        abbreviationDaylight: '-02/-01',
        id: 182
    },
    {
        name: 'Etc/GMT-2',
        displayName: 'GMT-02:00 GMT-2 -02',
        nameLocalized: 'GMT-2',
        abbreviationStandard: '-02',
        id: 376
    },
    {
        name: 'Etc/GMT+2',
        displayName: 'GMT-02:00 GMT+2 -02',
        nameLocalized: 'GMT+2',
        abbreviationStandard: '-02',
        id: 361
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 세인트존스 NST',
        nameLocalized: '세인트존스',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'Canada/Newfoundland',
        displayName: 'GMT-03:30 Newfoundland NST',
        nameLocalized: 'Newfoundland',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 341
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 고드호프 -03/-02',
        nameLocalized: '고드호프',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 라 리오하 -03',
        nameLocalized: '라 리오하',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 레시페 -03',
        nameLocalized: '레시페',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 로데라 -03',
        nameLocalized: '로데라',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 리오 가예고스 -03',
        nameLocalized: '리오 가예고스',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 마세이오 -03',
        nameLocalized: '마세이오',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 멘도사 -03',
        nameLocalized: '멘도사',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 몬테비데오 -03/-02',
        nameLocalized: '몬테비데오',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 미클롱 -03/-02',
        nameLocalized: '미클롱',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 바히아 -03',
        nameLocalized: '바히아',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 벨렘 -03',
        nameLocalized: '벨렘',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 부에노스 아이레스 -03/-02',
        nameLocalized: '부에노스 아이레스',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 산후안 -03',
        nameLocalized: '산후안',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 상파울루 -03/-02',
        nameLocalized: '상파울루',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 스탠리 -03',
        nameLocalized: '스탠리',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 아라과이나 -03',
        nameLocalized: '아라과이나',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 우수아이아 -03',
        nameLocalized: '우수아이아',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 카옌 -03',
        nameLocalized: '카옌',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 카타마르카 -03',
        nameLocalized: '카타마르카',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 코르도바 -03/-02',
        nameLocalized: '코르도바',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 투쿠만 -03/-02',
        nameLocalized: '투쿠만',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 파라마리보 -03',
        nameLocalized: '파라마리보',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 파머 -03',
        nameLocalized: '파머',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 포르탈레자 -03',
        nameLocalized: '포르탈레자',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 후후이 -03',
        nameLocalized: '후후이',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 59
    },
    {
        name: 'America/Argentina/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 60
    },
    {
        name: 'America/Argentina/ComodRivadavia',
        displayName: 'GMT-03:00 ComodRivadavia -03',
        nameLocalized: 'ComodRivadavia',
        abbreviationStandard: '-03',
        id: 61
    },
    {
        name: 'America/Argentina/Cordoba',
        displayName: 'GMT-03:00 Cordoba -03/-02',
        nameLocalized: 'Cordoba',
        abbreviationStandard: '-03/-02',
        id: 62
    },
    {
        name: 'Brazil/East',
        displayName: 'GMT-03:00 East -03/-02',
        nameLocalized: 'East',
        abbreviationStandard: '-03/-02',
        id: 334
    },
    {
        name: 'Etc/GMT-3',
        displayName: 'GMT-03:00 GMT-3 -03',
        nameLocalized: 'GMT-3',
        abbreviationStandard: '-03',
        id: 377
    },
    {
        name: 'Etc/GMT+3',
        displayName: 'GMT-03:00 GMT+3 -03',
        nameLocalized: 'GMT+3',
        abbreviationStandard: '-03',
        id: 362
    },
    {
        name: 'America/Argentina/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 63
    },
    {
        name: 'America/Argentina/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 65
    },
    {
        name: 'America/Rosario',
        displayName: 'GMT-03:00 Rosario -03/-02',
        nameLocalized: 'Rosario',
        abbreviationStandard: '-03/-02',
        id: 178
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 가이아나 -04',
        nameLocalized: '가이아나',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 과들루프 AST',
        nameLocalized: '과들루프',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 구즈베이 AST',
        nameLocalized: '구즈베이',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 그레나다 AST',
        nameLocalized: '그레나다',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 글라스베이 AST',
        nameLocalized: '글라스베이',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 도미니카 AST',
        nameLocalized: '도미니카',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 라파스 -04',
        nameLocalized: '라파스',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 마나우스 -04',
        nameLocalized: '마나우스',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 마티니크 AST',
        nameLocalized: '마티니크',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 몬세라트 AST',
        nameLocalized: '몬세라트',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 몽턴 AST',
        nameLocalized: '몽턴',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 바베이도스 AST',
        nameLocalized: '바베이도스',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 버뮤다 AST',
        nameLocalized: '버뮤다',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 보아 비스타 -04',
        nameLocalized: '보아 비스타',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 블랑 사블롱 AST',
        nameLocalized: '블랑 사블롱',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 산토도밍고 AST',
        nameLocalized: '산토도밍고',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 산티아고 -04/-03',
        nameLocalized: '산티아고',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 세인트루시아 AST',
        nameLocalized: '세인트루시아',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 세인트빈센트 AST',
        nameLocalized: '세인트빈센트',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 세인트키츠 AST',
        nameLocalized: '세인트키츠',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 세인트토마스 AST',
        nameLocalized: '세인트토마스',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 아루바 AST',
        nameLocalized: '아루바',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 아순시온 -04/-03',
        nameLocalized: '아순시온',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 안티과 AST',
        nameLocalized: '안티과',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 앙귈라 AST',
        nameLocalized: '앙귈라',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 카라카스 -04',
        nameLocalized: '카라카스',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 캄포 그란데 -04/-03',
        nameLocalized: '캄포 그란데',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 쿠이아바 -04/-03',
        nameLocalized: '쿠이아바',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 퀴라소 AST',
        nameLocalized: '퀴라소',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 토르톨라 AST',
        nameLocalized: '토르톨라',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 툴레 AST',
        nameLocalized: '툴레',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 포르토벨료 -04',
        nameLocalized: '포르토벨료',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 포트오브스페인 AST',
        nameLocalized: '포트오브스페인',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 푸에르토리코 AST',
        nameLocalized: '푸에르토리코',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 핼리팩스 AST',
        nameLocalized: '핼리팩스',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'Chile/Continental',
        displayName: 'GMT-04:00 Continental -04/-03',
        nameLocalized: 'Continental',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 346
    },
    {
        name: 'Etc/GMT-4',
        displayName: 'GMT-04:00 GMT-4 -04',
        nameLocalized: 'GMT-4',
        abbreviationStandard: '-04',
        id: 378
    },
    {
        name: 'Etc/GMT+4',
        displayName: 'GMT-04:00 GMT+4 -04',
        nameLocalized: 'GMT+4',
        abbreviationStandard: '-04',
        id: 363
    },
    {
        name: 'America/Virgin',
        displayName: 'GMT-04:00 Virgin AST',
        nameLocalized: 'Virgin',
        abbreviationStandard: 'AST',
        id: 197
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 과야킬 -05/-04',
        nameLocalized: '과야킬',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 그랜드 터크 EST',
        nameLocalized: '그랜드 터크',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 나소 EST',
        nameLocalized: '나소',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 뉴욕 EST',
        nameLocalized: '뉴욕',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 디트로이트 EST',
        nameLocalized: '디트로이트',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 루이빌 EST',
        nameLocalized: '루이빌',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 리마 -05/-04',
        nameLocalized: '리마',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 보고타 -05/-04',
        nameLocalized: '보고타',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 아이루네페 -05',
        nameLocalized: '아이루네페',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 이칼루이트 EST',
        nameLocalized: '이칼루이트',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 인디애나주, 머렝고 EST',
        nameLocalized: '인디애나주, 머렝고',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 인디애나주, 비비 EST',
        nameLocalized: '인디애나주, 비비',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 인디애나주, 빈센스 EST',
        nameLocalized: '인디애나주, 빈센스',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 인디애나주, 위너맥 EST',
        nameLocalized: '인디애나주, 위너맥',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 인디애나주, 피츠버그 EST',
        nameLocalized: '인디애나주, 피츠버그',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 인디애나폴리스 EST',
        nameLocalized: '인디애나폴리스',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 자메이카 EST',
        nameLocalized: '자메이카',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 칸쿤 EST',
        nameLocalized: '칸쿤',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 케이맨 EST',
        nameLocalized: '케이맨',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 켄터키주, 몬티첼로 EST',
        nameLocalized: '켄터키주, 몬티첼로',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 코랄하버 EST',
        nameLocalized: '코랄하버',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 토론토 EST',
        nameLocalized: '토론토',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 파나마 EST',
        nameLocalized: '파나마',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 포르토프랭스 EST',
        nameLocalized: '포르토프랭스',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 하바나 CST',
        nameLocalized: '하바나',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 히우 브랑쿠 -05',
        nameLocalized: '히우 브랑쿠',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'Brazil/Acre',
        displayName: 'GMT-05:00 Acre -05',
        nameLocalized: 'Acre',
        abbreviationStandard: '-05',
        id: 332
    },
    {
        name: 'America/Atikokan',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 72
    },
    {
        name: 'US/East-Indiana',
        displayName: 'GMT-05:00 East-Indiana EST',
        nameLocalized: 'East-Indiana',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 539
    },
    {
        name: 'US/Eastern',
        displayName: 'GMT-05:00 Eastern EST',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 540
    },
    {
        name: 'EST',
        displayName: 'GMT-05:00 EST EST',
        nameLocalized: 'EST',
        abbreviationStandard: 'EST',
        id: 353
    },
    {
        name: 'EST5EDT',
        displayName: 'GMT-05:00 EST5EDT EST',
        nameLocalized: 'EST5EDT',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 354
    },
    {
        name: 'America/Fort_Wayne',
        displayName: 'GMT-05:00 Fort Wayne EST',
        nameLocalized: 'Fort Wayne',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 107
    },
    {
        name: 'Etc/GMT-5',
        displayName: 'GMT-05:00 GMT-5 -05',
        nameLocalized: 'GMT-5',
        abbreviationStandard: '-05',
        id: 379
    },
    {
        name: 'Etc/GMT+5',
        displayName: 'GMT-05:00 GMT+5 -05',
        nameLocalized: 'GMT+5',
        abbreviationStandard: '-05',
        id: 364
    },
    {
        name: 'America/Indiana/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 121
    },
    {
        name: 'America/Kentucky/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 134
    },
    {
        name: 'America/Montreal',
        displayName: 'GMT-05:00 Montreal EST',
        nameLocalized: 'Montreal',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 154
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 Nipigon EST',
        nameLocalized: 'Nipigon',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 Pangnirtung EST',
        nameLocalized: 'Pangnirtung',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Porto_Acre',
        displayName: 'GMT-05:00 Porto Acre -05',
        nameLocalized: 'Porto Acre',
        abbreviationStandard: '-05',
        id: 169
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 Thunder Bay EST',
        nameLocalized: 'Thunder Bay',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 갈라파고스 -06/-05',
        nameLocalized: '갈라파고스',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 과테말라 CST',
        nameLocalized: '과테말라',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 노스다코타주, 뉴살렘 CST',
        nameLocalized: '노스다코타주, 뉴살렘',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 랭킹 인렛 CST',
        nameLocalized: '랭킹 인렛',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 리자이나 CST',
        nameLocalized: '리자이나',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 리졸루트 CST',
        nameLocalized: '리졸루트',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 마나과 CST',
        nameLocalized: '마나과',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 메노미니 CST',
        nameLocalized: '메노미니',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 메리다 CST',
        nameLocalized: '메리다',
        abbreviationStandard: 'CST',
        id: 148
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 멕시코 시티 CST',
        nameLocalized: '멕시코 시티',
        abbreviationStandard: 'CST',
        id: 149,
        enabled: true
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 몬테레이 CST',
        nameLocalized: '몬테레이',
        abbreviationStandard: 'CST',
        id: 152
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 벨리즈 CST',
        nameLocalized: '벨리즈',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 스위프트커런트 CST',
        nameLocalized: '스위프트커런트',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 시카고 CST',
        nameLocalized: '시카고',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 엘살바도르 CST',
        nameLocalized: '엘살바도르',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 위니펙 CST',
        nameLocalized: '위니펙',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 이스터 섬 -06/-05',
        nameLocalized: '이스터 섬',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 인디애나주, 녹스 CST',
        nameLocalized: '인디애나주, 녹스',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 중부, 노스다코타 CST',
        nameLocalized: '중부, 노스다코타',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-06:00 치와와 CST',
        nameLocalized: '치와와',
        abbreviationStandard: 'CST',
        id: 91,
        enabled: true
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 코스타리카 CST',
        nameLocalized: '코스타리카',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 테구시갈파 CST',
        nameLocalized: '테구시갈파',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'Canada/Central',
        displayName: 'GMT-06:00 Central CST',
        nameLocalized: 'Central',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 337
    },
    {
        name: 'CST6CDT',
        displayName: 'GMT-06:00 CST6CDT CST',
        nameLocalized: 'CST6CDT',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 348
    },
    {
        name: 'Mexico/General',
        displayName: 'GMT-06:00 General CST',
        nameLocalized: 'General',
        abbreviationStandard: 'CST',
        id: 479
    },
    {
        name: 'Etc/GMT-6',
        displayName: 'GMT-06:00 GMT-6 -06',
        nameLocalized: 'GMT-6',
        abbreviationStandard: '-06',
        id: 380
    },
    {
        name: 'Etc/GMT+6',
        displayName: 'GMT-06:00 GMT+6 -06',
        nameLocalized: 'GMT+6',
        abbreviationStandard: '-06',
        id: 365
    },
    {
        name: 'US/Indiana-Starke',
        displayName: 'GMT-06:00 Indiana-Starke CST',
        nameLocalized: 'Indiana-Starke',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 542
    },
    {
        name: 'America/Knox_IN',
        displayName: 'GMT-06:00 Knox IN CST',
        nameLocalized: 'Knox IN',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 136
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 Rainy River CST',
        nameLocalized: 'Rainy River',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 덴버 MST',
        nameLocalized: '덴버',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 도슨 MST',
        nameLocalized: '도슨',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 도슨크릭 MST',
        nameLocalized: '도슨크릭',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 마사틀란 MST',
        nameLocalized: '마사틀란',
        abbreviationStandard: 'MST',
        id: 145
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 보이시 MST',
        nameLocalized: '보이시',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 에드먼턴 MST',
        nameLocalized: '에드먼턴',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 에르모시요 MST',
        nameLocalized: '에르모시요',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 이누빅 MST',
        nameLocalized: '이누빅',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 케임브리지 베이 MST',
        nameLocalized: '케임브리지 베이',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 피닉스 MST',
        nameLocalized: '피닉스',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 화이트호스 MST',
        nameLocalized: '화이트호스',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'Mexico/BajaSur',
        displayName: 'GMT-07:00 BajaSur MST',
        nameLocalized: 'BajaSur',
        abbreviationStandard: 'MST',
        id: 478
    },
    {
        name: 'Etc/GMT-7',
        displayName: 'GMT-07:00 GMT-7 -07',
        nameLocalized: 'GMT-7',
        abbreviationStandard: '-07',
        id: 381
    },
    {
        name: 'Etc/GMT+7',
        displayName: 'GMT-07:00 GMT+7 -07',
        nameLocalized: 'GMT+7',
        abbreviationStandard: '-07',
        id: 366
    },
    {
        name: 'Canada/Mountain',
        displayName: 'GMT-07:00 Mountain MST',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 340
    },
    {
        name: 'MST',
        displayName: 'GMT-07:00 MST MST',
        nameLocalized: 'MST',
        abbreviationStandard: 'MST',
        id: 480
    },
    {
        name: 'MST7MDT',
        displayName: 'GMT-07:00 MST7MDT MST',
        nameLocalized: 'MST7MDT',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 481
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 Yellowknife MST',
        nameLocalized: 'Yellowknife',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'Canada/Yukon',
        displayName: 'GMT-07:00 Yukon MST',
        nameLocalized: 'Yukon',
        abbreviationStandard: 'MST',
        id: 344
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 로스앤젤레스 PST',
        nameLocalized: '로스앤젤레스',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 벤쿠버 PST',
        nameLocalized: '벤쿠버',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 티후아나 PST',
        nameLocalized: '티후아나',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 핏케언 -08',
        nameLocalized: '핏케언',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'America/Ensenada',
        displayName: 'GMT-08:00 Ensenada PST',
        nameLocalized: 'Ensenada',
        abbreviationStandard: 'PST',
        id: 106
    },
    {
        name: 'Etc/GMT-8',
        displayName: 'GMT-08:00 GMT-8 -08',
        nameLocalized: 'GMT-8',
        abbreviationStandard: '-08',
        id: 382
    },
    {
        name: 'Etc/GMT+8',
        displayName: 'GMT-08:00 GMT+8 -08',
        nameLocalized: 'GMT+8',
        abbreviationStandard: '-08',
        id: 367
    },
    {
        name: 'Canada/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 342
    },
    {
        name: 'US/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 545
    },
    {
        name: 'PST8PDT',
        displayName: 'GMT-08:00 PST8PDT PST',
        nameLocalized: 'PST8PDT',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 528
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 마퀘사스 -0930',
        nameLocalized: '마퀘사스',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 감비어 -09',
        nameLocalized: '감비어',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 놈 AKST',
        nameLocalized: '놈',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 앵커리지 AKST',
        nameLocalized: '앵커리지',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 야쿠타트 AKST',
        nameLocalized: '야쿠타트',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 주노 AKST',
        nameLocalized: '주노',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'US/Alaska',
        displayName: 'GMT-09:00 Alaska AKST',
        nameLocalized: 'Alaska',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 535
    },
    {
        name: 'Etc/GMT-9',
        displayName: 'GMT-09:00 GMT-9 -09',
        nameLocalized: 'GMT-9',
        abbreviationStandard: '-09',
        id: 383
    },
    {
        name: 'Etc/GMT+9',
        displayName: 'GMT-09:00 GMT+9 -09',
        nameLocalized: 'GMT+9',
        abbreviationStandard: '-09',
        id: 368
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 라로통가 -10/-0930',
        nameLocalized: '라로통가',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 에이닥 HST',
        nameLocalized: '에이닥',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 타히티 -10',
        nameLocalized: '타히티',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 호놀룰루 HST',
        nameLocalized: '호놀룰루',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'Etc/GMT-10',
        displayName: 'GMT-10:00 GMT-10 -10',
        nameLocalized: 'GMT-10',
        abbreviationStandard: '-10',
        id: 371
    },
    {
        name: 'Etc/GMT+10',
        displayName: 'GMT-10:00 GMT+10 -10',
        nameLocalized: 'GMT+10',
        abbreviationStandard: '-10',
        id: 358
    },
    {
        name: 'US/Hawaii',
        displayName: 'GMT-10:00 Hawaii HST',
        nameLocalized: 'Hawaii',
        abbreviationStandard: 'HST',
        id: 541
    },
    {
        name: 'HST',
        displayName: 'GMT-10:00 HST HST',
        nameLocalized: 'HST',
        abbreviationStandard: 'HST',
        id: 457
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 Johnston HST',
        nameLocalized: 'Johnston',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 니우에 -11',
        nameLocalized: '니우에',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 미드웨이 SST',
        nameLocalized: '미드웨이',
        abbreviationStandard: 'SST',
        id: 505,
        enabled: true
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 파고파고 SST',
        nameLocalized: '파고파고',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Etc/GMT-11',
        displayName: 'GMT-11:00 GMT-11 -11',
        nameLocalized: 'GMT-11',
        abbreviationStandard: '-11',
        id: 372
    },
    {
        name: 'Etc/GMT+11',
        displayName: 'GMT-11:00 GMT+11 -11',
        nameLocalized: 'GMT+11',
        abbreviationStandard: '-11',
        id: 359
    },
    {
        name: 'Pacific/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 517
    },
    {
        name: 'US/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 547
    },
    {
        name: 'Etc/GMT-12',
        displayName: 'GMT-12:00 GMT-12 -12',
        nameLocalized: 'GMT-12',
        abbreviationStandard: '-12',
        id: 373
    },
    {
        name: 'Etc/GMT+12',
        displayName: 'GMT-12:00 GMT+12 -12',
        nameLocalized: 'GMT+12',
        abbreviationStandard: '-12',
        id: 360
    },
];

const weekData: WeekData = {
    firstDay: 0,
    weekendStart: 6,
    weekendEnd: 0
};

const weekDayNames: WeekDayNameData = {
    days: {
        abbreviated: {
            sun: '일',
            mon: '월',
            tue: '화',
            wed: '수',
            thu: '목',
            fri: '금',
            sat: '토',
        },
        narrow: {
            sun: '일',
            mon: '월',
            tue: '화',
            wed: '수',
            thu: '목',
            fri: '금',
            sat: '토',
        },
        short: {
            sun: '일',
            mon: '월',
            tue: '화',
            wed: '수',
            thu: '목',
            fri: '금',
            sat: '토',
        },
        wide: {
            sun: '일요일',
            mon: '월요일',
            tue: '화요일',
            wed: '수요일',
            thu: '목요일',
            fri: '금요일',
            sat: '토요일',
        },
    },
    standAlone: {
        abbreviated: {
            sun: '일',
            mon: '월',
            tue: '화',
            wed: '수',
            thu: '목',
            fri: '금',
            sat: '토',
        },
        narrow: {
            sun: '일',
            mon: '월',
            tue: '화',
            wed: '수',
            thu: '목',
            fri: '금',
            sat: '토',
        },
        short: {
            sun: '일',
            mon: '월',
            tue: '화',
            wed: '수',
            thu: '목',
            fri: '금',
            sat: '토',
        },
        wide: {
            sun: '일요일',
            mon: '월요일',
            tue: '화요일',
            wed: '수요일',
            thu: '목요일',
            fri: '금요일',
            sat: '토요일',
        },
    },
};

const data: LocaleData = {
    languages,
    numbers,
    timezones,
    weekData,
    weekDayNames
};

export default data;
